import { AnyIcon } from '@liveauctioneers/hammer-ui-core/icons/anyIcon';
import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import { Headset, Lock, SealCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { InverseLink } from '@liveauctioneers/hammer-ui-core/link';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useTrackPurchaseProtectionLearnMoreAnalytics } from '@/utils/amplitude/analytics/purchaseProtection/trackPurchaseProtectionLearnMore.analytics';

type TrustPoint = {
    description: string;
    icon: AnyIcon;
    title: string;
    trackingDescription: string;
    trackingEvent: string;
    url: string;
};

export const TRUST_POINTS: TrustPoint[] = [
    {
        description: 'Bid on items sold through our network of verified auction houses.',
        icon: SealCheck,
        title: 'A Network You Can Trust',
        trackingDescription:
            'User clicks on the "Learn More" link in the "A Network You Can Trust" section on purchase protection page',
        trackingEvent: TrackingEvents.PurchaseProtection.LearnMoreNetwork,
        url: 'https://help.liveauctioneers.com/hc/en-gb/articles/36967974634641-The-LiveAuctioneers-Seller-Network',
    },
    {
        description: 'Thousands of payments processed through LiveAuctioneers, every day.',
        icon: Lock,
        title: 'Secure, Online Bidding',
        trackingDescription:
            'User clicks on the "Learn More" link in the "Secure, Online Bidding" section on purchase protection page',
        trackingEvent: TrackingEvents.PurchaseProtection.LearnMoreSecureBidding,
        url: 'https://help.liveauctioneers.com/hc/en-gb/articles/24714724715793-Paying-through-LiveAuctioneers',
    },
    {
        description: 'Real help from real people, whenever you need it.',
        icon: Headset,
        title: 'Dedicated Expert Support',
        trackingDescription:
            'User clicks on the "Learn More" link in the "Dedicated Expert Support" section on purchase protection page',
        trackingEvent: TrackingEvents.PurchaseProtection.LearnMoreDedicatedSupport,
        url: 'https://help.liveauctioneers.com/hc/en-gb',
    },
];

export const PurchaseProtectionTrust = () => {
    const trackPurchaseProtectionLearnMoreAnalytics = useTrackPurchaseProtectionLearnMoreAnalytics();
    const { formatMessage } = useIntl();
    return (
        <div className="bg-background-inverse px-md xsMax:px-sm">
            <div className="mx-auto max-w-[1200px] py-[96px] xsMax:py-2xl">
                <div className="grid grid-cols-3 gap-2xl xsMax:grid-cols-1 xsMax:grid-rows-3 xsMax:gap-xl">
                    {TRUST_POINTS.map(({ description, icon: Icon, title, trackingDescription, trackingEvent, url }) => (
                        <div
                            className="flex flex-col gap-sm xsMax:items-center xsMax:text-center"
                            key={title}
                        >
                            <Icon
                                color="inverse"
                                size="lg"
                                style="duotone"
                            />
                            <div className="flex flex-col gap-2xs">
                                <H2 color="inverse">{title}</H2>
                                <BodyPrimary color="inverse">{description}</BodyPrimary>
                            </div>
                            <InverseLink
                                href={url}
                                onClick={() =>
                                    trackPurchaseProtectionLearnMoreAnalytics(trackingEvent, {
                                        description: trackingDescription,
                                    })
                                }
                                target="_blank"
                            >
                                {formatMessage({ id: 'purchaseProtectionPage.hero.learnMore' })}
                            </InverseLink>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
